import { ITypedReduxAction } from '../../types/redux/actionType';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export enum EPhoneValidationActionTypes {
  OpenPhoneValidation = 'phoneValidation/OPEN_FORM',
  SetFailure = 'phoneValidation/SET_FAILURE',
  SetError = 'phoneValidation/SET_ERROR',
  SetSubmitting = 'phoneValidation/SET_SUBMITTING',
  SetSuccess = 'phoneValidation/SET_SUCCESS',
}

export type TOpenPhoneValidationForm = ITypedReduxAction<EPhoneValidationActionTypes.OpenPhoneValidation>;
export type TSetPhoneValidationFailure = ITypedReduxAction<
  EPhoneValidationActionTypes.SetFailure,
  { secondsToRetry?: number }
>;
export type TSetPhoneValidationSubmitting = ITypedReduxAction<EPhoneValidationActionTypes.SetSubmitting>;
export type TSetPhoneValidationSuccess = ITypedReduxAction<
  EPhoneValidationActionTypes.SetSuccess,
  { secondsToRetry?: number }
>;
export type TSetPhoneValidationError = ITypedReduxAction<
  EPhoneValidationActionTypes.SetError,
  { secondsToRetry?: number; error?: string; phoneError?: string; timeError?: string }
>;

export const openPhoneValidation = actionGenerator<EPhoneValidationActionTypes.OpenPhoneValidation>(
  EPhoneValidationActionTypes.OpenPhoneValidation,
);

export const setRequestFailure = actionGenerator<EPhoneValidationActionTypes.SetFailure, { secondsToRetry?: number }>(
  EPhoneValidationActionTypes.SetFailure,
);

export const setRequestSubmitting = actionGenerator<EPhoneValidationActionTypes.SetSubmitting>(
  EPhoneValidationActionTypes.SetSubmitting,
);

export const setRequestSuccess = actionGenerator<EPhoneValidationActionTypes.SetSuccess, { secondsToRetry?: number }>(
  EPhoneValidationActionTypes.SetSuccess,
);

export const setPhoneConfirmationError = actionGenerator<
  EPhoneValidationActionTypes.SetError,
  { secondsToRetry?: number; error?: string; phoneError?: string; timeError?: string }
>(EPhoneValidationActionTypes.SetError);

export type TPhoneValidationActions =
  | TOpenPhoneValidationForm
  | TSetPhoneValidationFailure
  | TSetPhoneValidationSubmitting
  | TSetPhoneValidationSuccess
  | TSetPhoneValidationError;
